import React from "react";
import { Address, DocumentUrl, SectionModel } from "../../../../../models/guarantorCheque.model";
import DivisionCmp from "../../../../../components/cards/DivisionCmp";
import DetailInfoComponentThumbnail from "../../../../../components/thumbnail/detailInfoComponentThumbnail";


interface SchemaInfoModel {
    data?: Address;
    documentList: DocumentUrl[];
    withoutDoc: boolean;
}
const sections: SectionModel[] = [
    { dataKey: "postalCode", rowCol: 3, title: " کدپستی" },
    { dataKey: "inquityAddress", rowCol: 3, title: " آدرس" },
];

export default function GuarantorPlaceInfo(props: any) {
    return (
        <>
            <DivisionCmp child={<DetailInfoComponentThumbnail
                sections={sections}
                data={props}
                documentList={props.data}
                height={"20vh"}
                addressByInquiry={true}
                showFooter={false}
                isGuarantor={true}
            // showDoc={withoutDoc}
            />} title={props.title ? props.title : "اطلاعات سکونتی"} className={'mTop5'} />
        </>
    );
}
